/**
 * Describes current viewport size and scaling.
 */
export class ViewportState {
  /** Width of the visible window */
  windowWidth: number = 0

  /** Height of the visible window */
  windowHeight: number = 0

  /** Full scroll width (content width inside scroll container) */
  contentWidth: number = 0

  /** Full scroll height (content height inside scroll container) */
  contentHeight: number = 0

  /** Screen scale ratio for width (e.g. device pixel ratio or zoom level) */
  scaleWidth: number = 1

  /** Screen scale ratio for height */
  scaleHeight: number = 1

  transformScale: number = 1

  baseRem: number = 16
}
